import { render } from "./CRMProductSaleView.vue?vue&type=template&id=b0bd35fa&scoped=true"
import script from "./CRMProductSaleView.vue?vue&type=script&lang=js"
export * from "./CRMProductSaleView.vue?vue&type=script&lang=js"

import "./CRMProductSaleView.vue?vue&type=style&index=0&id=b0bd35fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0bd35fa"]])

export default __exports__